import { render, staticRenderFns } from "./FeLoadData.vue?vue&type=template&id=63635f5b&"
import script from "./FeLoadData.vue?vue&type=script&lang=js&"
export * from "./FeLoadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports